//This is the meet the developers page

import MeetTheDevelopersComponent from "../NonMVPComponents/MeetTheDevelopersComponent";

const MeetTheDevelopers = () => {
  return (
    <div>
      <MeetTheDevelopersComponent />
    </div>
  );
};

export default MeetTheDevelopers;
